<template>
	<div class="finance-product-tabs" role="tablist">
		<button
			v-for="(tab, index) in tabs"
			:key="tab"
			class="finance-product-tabs__item"
			:class="{ active: value === index }"
			:aria-selected="value === index"
			role="tab"
			@click="$emit('input', index)"
		>
			{{ tab }}
		</button>
	</div>
</template>

<script>
export default {
	name: 'FinanceProductTabs',
	props: {
		value: {
			type: Number,
			default: 0
		},
		tabs: {
			type: Array,
			default: () => []
		}
	}
}
</script>

<style scoped lang="scss">
@import '~@nio-fe/nio-app-ui/es/style';

.finance-product-tabs {
	display: flex;
	box-sizing: border-box;
	margin: 0 20px;
	border: 1px solid var(--border_divider_primary);
}

.finance-product-tabs__item {
	flex: 1 0 0;
	min-width: 0;
	padding: 6px 15px;
	border: 0;
	background: var(--bg_secondary);
	color: var(--text_secondary);
	@include body_2(1.5, 400, false);
	text-align: center;
	white-space: nowrap;

	&.active {
		background: var(--bg_primary);
		color: var(--text_primary);
		@include body_2(1.5, 500, false);
	}
}
</style>
